import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileIcon, defaultStyles } from 'react-file-icon';
import axios from "axios";
import { headers } from '../../token';
import config from "../../config";
import { saveAs } from 'file-saver';
import { Flat } from '@alptugidin/react-circular-progress-bar';
import UpdateMouldFile from "./UpdateMouldFile";
import DeleteMouldFile from "./DeleteMouldFile";
import ViewsMouldFile from "./ViewsMouldFile";
import vAdminformat from "../../adminFormat";
import Swal from "sweetalert2";
import validateError from "../../ValidateError";
import ColorBox from "../ColorBox";

const server_backend = config.API_URL;

const MyStlMouldLibrary = ({ username }) => {
    const [isUploading, setIsUploading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isDragging, setIsDragging] = useState(false);
    const [isMinimized, setIsMinimized] = useState(false);
    const [getFiles, setGetFiles] = useState([]);
    const [DownloadModalFile, setDownloadModalFile] = useState(false);
    const [loadingFilesInServer, setLoadingFilesInServer] = useState(false);
    const [files, setFiles] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [ViewFile, setViewFile] = useState(false);
    const [CurrenURLFile, setCurrenURLFile] = useState("");
    const [statusFiles, setStatusFiles] = useState([]);

    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState("");
    const [selectedFilter, setSelectedFilter] = useState("");
    const [currentObject, setcurrentObject] = useState("");
    const [onFileID, setOnFileID] = useState(0);
    const [filesUploaded, setFilesUploaded] = useState([]);
    const [getMouldTypes, setGetMouldTypes] = useState([]);
    const [getMouldConditions, setGetMouldConditions] = useState([]);
    const [getMouldOrigins, setGetMouldOrigins] = useState([]);
    const [materialList, setMaterialList] = useState([]);
    const [selectedMaterial, setSelectedMaterial] = useState(0);
    const [showDropdown, setShowDropdown] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);
    const [formFields, setFormFields] = useState({
    });

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const CHUNK_SIZE = 10240 * 10240;

    useEffect(() => {
        const getMouldLibrary = async () => {
            try {
                const response = await axios.get(`${server_backend}/files/moulds/private/list`, headers);
                console.log("Unexpected error, please check")
                if (response.data.RES_CODE === "00") {
                    setGetFiles(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getMouldLibrary();
    }, []);

    useEffect(() => {
        const getMouldType = async () => {
            try {
                const response = await axios.get(`${server_backend}/mould_types/list`, headers);
                //console.log("Unexpected error, please check")


                if (response.data.RES_CODE === "00") {
                    setGetMouldTypes(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getMouldType();
    }, []);

    useEffect(() => {
        const getMouldConditions = async () => {
            try {
                const response = await axios.get(`${server_backend}/mould_conditions/list`, headers);
                //console.log("Unexpected error, please check")


                if (response.data.RES_CODE === "00") {
                    setGetMouldConditions(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getMouldConditions();
    }, []);

    useEffect(() => {
        const getMouldOrigins = async () => {
            try {
                const response = await axios.get(`${server_backend}/mould_origins/list`, headers);
                //console.log("Unexpected error, please check")


                if (response.data.RES_CODE === "00") {
                    setGetMouldOrigins(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getMouldOrigins();
    }, []);


    useEffect(() => {
        const getMaterial = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setMaterialList(response.data.RES_RESULT);

                    setFormFields((prevData) => ({
                        ...prevData,
                        mat_id: response.data.RES_RESULT[0].mat_ID,
                    }));
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getMaterial();
    }, [isUploading]);

     //These two hooks are used to correctly select the first material once the corresponding variables have been updated.
        useEffect(() => {
            if (materialList && materialList.length > 0 && formFields.mat_id && !isInitialized) {
                const selectedMaterial = materialList.find(material => material.mat_ID === formFields.mat_id);
    
                if (selectedMaterial) {
                    handleMaterialSelect(selectedMaterial);
                    setIsInitialized(true); // Set the flag to true after selecting the material
                }
            }
        }, [materialList, formFields.mat_id, isInitialized]);

    const handleMaterialSelect = (material) => {
        setSelectedMaterial(material);
        setFormFields({ ...formFields, mat_id: material.mat_ID });
        setShowDropdown(false);
    };

    const handleFileSelect = (event) => {
        const files = Array.from(event.target.files);
        setSelectedFiles(files);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragging(true);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files);
        setSelectedFiles(files);
        setIsDragging(false);
    };

    const getMouldLibrary = async () => {
        try {
            const response = await axios.get(`${server_backend}/files/moulds/private/list`, headers);

            if (response.data.RES_CODE === "00") {
                setGetFiles(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    const handleUpload = async () => {
        //Event.prevent default();

        console.log("Unexpected error, please check")
        if (!formFields.mould_name || selectedFiles.length === 0) {
            // Show an alert if the required fields are not filled


            Swal.fire({
                icon: 'warning',
                title: 'Alert',
                text: "Mould and file name are required.",
                showConfirmButton: true,
                confirmButtonText: 'Accept',
            });
            return;
        }

        setIsMinimized(false);
        setIsUploading(false);
        setLoadingFilesInServer(true);
        //console.log("Unexpected error, please check")


        const uploadFile = async (file) => {
            setDownloadModalFile(true);
            const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
            let fileName = file.name; // Original file name

            // Verify if the file already exists on the server

            try {
                const checkResponse = await axios.get(
                    `${server_backend}/files/moulds/private/exists?name=${file.name}`,
                    headers
                );

                if (checkResponse.data.RES_CODE === "00") {
                    // If it exists, generate a unique alias

                    const now = new Date();
                    const formattedDate = now.toISOString().replace(/[-:.TZ]/g, "");
                    const fileExtension = file.name.split(".").pop();
                    const fileBaseName = file.name.replace(`.${fileExtension}`, "");

                    fileName = `${fileBaseName}_${formattedDate}.${fileExtension}`;
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }

            // If the file does not exist, it proceeds with the rise by fragments

            for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                const start = chunkIndex * CHUNK_SIZE;
                const end = Math.min(start + CHUNK_SIZE, file.size);
                const chunk = file.slice(start, end);

                const formData = new FormData();

                formData.append("chunk", chunk);
                formData.append("chunkIndex", chunkIndex);
                formData.append("totalChunks", totalChunks);
                formData.append("name", fileName);  
                formData.append("user_transaction", username);
                formData.append("mould_material", formFields.mould_material);
                formData.append("mat_id", formFields.mat_id || 0);
                formData.append("mould_name", formFields.mould_name);
                formData.append("mould_reference", formFields.mould_reference || 0);
                formData.append("mould_type", formFields.mould_type || 0);
                formData.append("mould_condition", formFields.mould_condition || 0);
                formData.append("mould_origin", formFields.mould_origin || 0);
                formData.append("comment", formFields.comment);
                formData.append("mould_size", formFields.mould_size || 0);
                const config = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: headers.headers.Authorization,
                    },
                    onUploadProgress: (progressEvent) => {
                        const overallProgress = Math.round(
                            ((chunkIndex + 1) * 100) / totalChunks
                        );
                        // Update the progress of this file

                        setFiles((prevFiles) =>
                            prevFiles.map((f) =>
                                f.name === file.name
                                    ? { ...f, progress: overallProgress }
                                    : f
                            )
                        );
                    },
                };

                try {
                    await axios.post(
                        `${server_backend}/files/moulds/private/insert`,
                        formData,
                        config
                    );
                } catch (error) {
                    console.log("Unexpected error, please check")
                }
            }

            setFilesUploaded((prevFiles) => [...prevFiles, { name: fileName, progress: 100 }]);
        };

        try {

            const initialFiles = selectedFiles.map((file) => ({
                name: file.name,
                progress: 0,
            }));
            setFiles(initialFiles);


            for (let i = 0; i < selectedFiles.length; i++) {
                await uploadFile(selectedFiles[i]);
            }
        } catch (error) {
            const message = validateError(error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: message,
                showConfirmButton: true,
                confirmButtonText: 'Accept',
            });
            return;
        } finally {
            setLoadingFilesInServer(false);
            setFormFields([]);
            setSelectedFiles([]);
            getMouldLibrary();
            setIsUploading(false);
        }
    };

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
    };

    const FilterFiles = async () => {
        try {
            const response = await axios.get(`${server_backend}/files/moulds/private/search?user_transaction=${username}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            setGetFiles(response.data.RES_RESULT);
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterFiles();
        } else {
            getMouldLibrary();
        }
    }, [filterBy, filterStatus, filterValue, filtersEnabled]);

    const CloseModal = () => {
        setIsUpdating(false);
    };

    const ShowViewFiles = () => {
        setViewFile(true);
    }
    const CloseViewFiles = () => {
        setViewFile(false);
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = getFiles.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(getFiles.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Handle the checkboxes selection

    const handleCheckboxChange = (fileID) => {
        setSelectedFiles(prev =>
            prev.includes(fileID) ? prev.filter(id => id !== fileID) : [...prev, fileID]
        );
    };

    // Handles selected files
    const handleDeleteSelected = () => {

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to delete these file? This action cannot be undone.",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    selectedFiles.forEach(fileID => DeleteMouldFile(fileID));

                } catch (error) {
                    console.log("Unexpected error, please check")
                } finally {
                    setSelectedFiles([]);
                    getMouldLibrary();
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: "Success.",
                        showConfirmButton: false,
                        timer: 1000
                    })
                }
            }
        });
    };

    return (
        <div className="page-content" style={{ overflow: "auto" }}>
            {ViewFile ? (
                <ViewsMouldFile CloseViewFiles={CloseViewFiles} urlFile={CurrenURLFile} Object={currentObject} />
            ) : (
                <div>
                    {!isUploading ? (
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0">Mould List</h4>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a href="javascript: void(0);">Mould</a></li>
                                                <li className="breadcrumb-item active">List</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card" id="tasksList">
                                        <div className="card-header border-0">
                                            <div className="d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">All Moulds</h5>
                                                <div className="col-xxl-2 col-sm-2" style={{ paddingRight: "2px" }}>
                                                    {selectedFiles.length > 0 && (
                                                        <button className="btn btn-danger w-100" onClick={handleDeleteSelected}>
                                                            Delete {selectedFiles.length} File(s)
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                                    <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                        <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                                    </button>
                                                </div>
                                                <div className="flex-shrink-0">
                                                    <Link className="btn btn-success" onClick={() => setIsUploading(true)}>
                                                        <i className="ri-upload-2-fill me-1 align-bottom"></i> Add New Mould
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        {filtersEnabled && (
                                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                                <form>
                                                    <div className="row g-3">
                                                        <div className="col-4">
                                                            <div className="input-light">
                                                                <select
                                                                    className="form-control custom-select-style"
                                                                    disabled={!filtersEnabled}
                                                                    value={filterBy} // Change to filterby



                                                                    onChange={handleFilterByChange}
                                                                >
                                                                    <option>Filter by</option>
                                                                    <option value="mould_name">Name</option>
                                                                    <option value="mould_size">size</option>

                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-4">
                                                            <div className="input-light">
                                                                <select
                                                                    className="form-control custom-select-style"
                                                                    disabled={!filtersEnabled}
                                                                    onChange={handleFilterStatusChange}
                                                                >
                                                                    <option value={0}>Filter status</option>
                                                                    {statusFiles.map((status) => (
                                                                        <option value={status.est_ID}>{status.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="search-box">
                                                                <input
                                                                    type="text"
                                                                    className="form-control search bg-light border-light"
                                                                    placeholder="Search for tasks or something..."
                                                                    onChange={handleFilterValueChange}
                                                                />
                                                                <i className="ri-search-line search-icon"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        )}
                                        <div className="card-body">
                                            <div className="table-responsive table-card mb-4" style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}>


                                                <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th><input type="checkbox" disabled /></th>
                                                            <th scope="col">Mould Name</th>
                                                            <th scope="col">Type</th>
                                                            <th scope="col">Size</th>
                                                            <th scope="col">Upload Date</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentItems.map((Files_M) => (
                                                            <tr key={Files_M.file_ID}>

                                                                <td>
                                                                    <div className="form-check">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id={`checkbox-${Files_M.file_ID}`}
                                                                            checked={selectedFiles.includes(Files_M.file_ID)}
                                                                            onChange={() => handleCheckboxChange(Files_M.file_ID)}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={`checkbox-${Files_M.file_ID}`}></label>
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <div className="d-flex align-items-center">
                                                                        <p className="text-bold mb-0">
                                                                            <Link
                                                                                onClick={() => {
                                                                                    ShowViewFiles();
                                                                                    const backendFilePath = `${server_backend}/${Files_M.path_file}`;
                                                                                    setCurrenURLFile(backendFilePath);
                                                                                    setcurrentObject(Files_M);
                                                                                }}
                                                                                className="text-truncate d-inline-block"
                                                                                style={{ maxWidth: '350px' }}
                                                                                title={Files_M.mould_name}
                                                                            >
                                                                                {Files_M.mould_name}
                                                                            </Link>
                                                                        </p>
                                                                    </div>
                                                                </td>
                                                                <td>{Files_M.mould_type}</td>
                                                                <td>{Files_M.mould_size}</td>
                                                                <td>{vAdminformat.FormatDate(Files_M.date_created)}</td>
                                                                <td>
                                                                    <span className={`${Files_M.est_ID === 1 ? "badge badge-soft-success text-uppercase"
                                                                        : (Files_M.est_ID === 2 ? "badge badge-soft-danger text-uppercase"
                                                                            : (Files_M.est_ID === 3 ? "badge badge-label bg-danger" : null)
                                                                        )} text-uppercase`}>
                                                                        {Files_M.status_name}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex align-items-center justify-content-around">
                                                                        <Link className="text-muted" onClick={() => {
                                                                            ShowViewFiles();
                                                                            const backendFilePath = `${server_backend}/${Files_M.path_file}`;
                                                                            setCurrenURLFile(backendFilePath);
                                                                            setcurrentObject(Files_M);
                                                                        }}>
                                                                            <i className="ri-eye-fill fs-5"></i>
                                                                        </Link>
                                                                        {/*<Link className="text-muted" onClick={() => {
                                                                            ShowModalUpdate();
                                                                            setOnFileID(Files_M.file_ID);
                                                                        }}>
                                                                            <i className="ri-pencil-fill fs-5"></i>
                                                                        </Link>
                                                                        */}
                                                                       {/*  <Link className="text-muted" onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            const backendFilePath = `${server_backend}/${Files_M.path_file}`;
                                                                            const fileNameWithoutSpaces = Files_M.name.replace(/\s/g, '');
                                                                            saveAs(backendFilePath, fileNameWithoutSpaces);
                                                                        }}>
                                                                            <i className="ri-download-2-fill fs-5"></i>
                                                                        </Link> */}
                                                                        <Link className="text-muted" onClick={() => {

                                                                            Swal.fire({
                                                                                icon: 'warning',
                                                                                title: 'Alert',
                                                                                text: "Are you sure you want to delete this file? This action cannot be undone.",
                                                                                showCancelButton: true,
                                                                                confirmButtonText: 'Accept',
                                                                                cancelButtonText: "Cancel"
                                                                            }).then(async (result) => {
                                                                                if (result.isConfirmed) {

                                                                                    DeleteMouldFile(Files_M.file_ID, getMouldLibrary);

                                                                                }
                                                                            });
                                                                        }}>
                                                                            <i className="ri-delete-bin-5-line fs-5"></i>
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="row justify-content-between align-items-center">
                                                <div className="col-auto me-3">
                                                    <p className="text-muted mb-sm-0">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, getFiles.length)} of {getFiles.length} entries</p>
                                                </div>
                                                <div className="col-auto">
                                                    <ul className="pagination pagination-separated pagination-sm justify-content-end mb-sm-0">
                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(currentPage - 1)} className="page-link">←</a>
                                                        </li>
                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                            <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                                <a href="#" onClick={() => handlePageChange(index + 1)} className="page-link">{index + 1}</a>
                                                            </li>
                                                        ))}
                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(currentPage + 1)} className="page-link">→</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="container-fluid">
                            <div className="card shadow-sm">
                                <div className="card-header bg-light">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h5 className="mb-0 fw-bold">🧱 Add New Mould</h5>
                                        <button className="btn btn-warning btn-sm" onClick={() => {

                                            setIsUploading(false)
                                            setSelectedFiles([]);

                                        }
                                        }>
                                            <i className="ri-arrow-left-line me-1"></i> Go back
                                        </button>
                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <div
                                                    className={`custom-scrollbar-wrapper ${isDragging ? "dragging" : ""}`}
                                                    style={{
                                                        minHeight: "29vh",
                                                        borderRadius: "10px",
                                                        border: "2px dashed #ccc",
                                                        padding: "20px",
                                                        backgroundColor: "#f8f9fa",
                                                    }}
                                                    onDragOver={handleDragOver}
                                                    onDrop={handleDrop}
                                                >
                                                    <div className="custom-file-input text-center mt-4">
                                                        <input
                                                            id="fileInput"
                                                            type="file"
                                                            style={{ display: "none" }}
                                                            onChange={handleFileSelect}
                                                            accept=".stl, .img, .jpg, .jpeg, .png, .obj"
                                                        />
                                                        <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
                                                            {selectedFiles.length > 0 ? (
                                                                <h5 className="fw-bold mb-2">Replace File</h5>
                                                            ) : (
                                                                <>
                                                                    <h5 className="fw-bold mb-2">📁 Drag file(s) here or click to upload</h5>
                                                                    <p className="text-muted">Supported formats: STL, JPG, PNG</p>
                                                                </>
                                                            )}
                                                        </label>
                                                    </div>
                                                    {selectedFiles.length > 0 && (
                                                        <ul className="list-group mt-3">
                                                            {selectedFiles.map((file, index) => (
                                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                                    {file.name}
                                                                    <span className="badge bg-primary rounded-pill">{Math.round(file.size / 1024)} KB</span>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="row mt-2">
                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-bold">Mould Name </label>
                                                        <input type="text" className="form-control" required onChange={(e) => setFormFields({ ...formFields, mould_name: e.target.value })} />
                                                    </div>

                                                    <div className="col-md-6 mb-3">
                                                        <label className="form-label fw-bold">Reference</label>
                                                        <input type="text" className="form-control" onChange={(e) => setFormFields({ ...formFields, mould_reference: e.target.value })} />
                                                    </div>

                                                    <div className="col-md-12 mb-3">
                                                        <label className="form-label fw-bold">Description</label>
                                                        <textarea className="form-control" rows={3} onChange={(e) => setFormFields({ ...formFields, comment: e.target.value })}></textarea>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label className="form-label fw-bold">Size</label>
                                                <input type="text" className="form-control" onChange={(e) => setFormFields({ ...formFields, mould_size: e.target.value })} />
                                            </div>
                                            <div className="col-6 ">
                                                <label className="form-label fw-bold text-muted">Metal</label>
                                                <div
                                                    style={{
                                                        minHeight: '14vh',
                                                        height: '14vh',
                                                        border: '1px solid #dcdcdc',
                                                        padding: "5px",
                                                        width: "100%",
                                                        overflowY: 'auto',
                                                    }}
                                                >
                                                    {materialList && materialList.length > 0 ? (
                                                        materialList.map((material) => (
                                                            <button
                                                                key={material.mat_ID}
                                                                className={`dropdown-item d-flex align-items-center justify-content-between ${selectedMaterial?.mat_ID === material.mat_ID ? 'bg-primary text-white' : ''}`}
                                                                type="button"
                                                                onClick={() => {
                                                                    handleMaterialSelect(material);
                                                                }}
                                                            >
                                                                <div className="d-flex align-items-center">
                                                                    <ColorBox color={material.color} />
                                                                    <span className="ms-2">{material.name}</span>
                                                                </div>
                                                            </button>
                                                        ))
                                                    ) : (
                                                        <button className="dropdown-item" type="button" disabled>
                                                            No materials found
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="row">

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label fw-bold">Type of Mould</label>
                                                <select className="form-select" onChange={(e) => setFormFields({ ...formFields, mould_type: e.target.value })}>
                                                    <option value={0}>Select Type</option>

                                                    {getMouldTypes && getMouldTypes.length > 0 ? (
                                                        getMouldTypes.map((type) => (
                                                            <option key={type.mti_ID} value={type.mti_ID}>{type.name}</option>
                                                        ))
                                                    ) : (
                                                        <option value="">No types available</option>
                                                    )}
                                                </select>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label fw-bold">Mould Origin</label>
                                                <select className="form-select" onChange={(e) => setFormFields({ ...formFields, mould_origin: e.target.value })}>
                                                    <option value={0}>Select Origin</option>

                                                    {getMouldOrigins && getMouldOrigins.length > 0 ? (
                                                        getMouldOrigins.map((origin) => (
                                                            <option key={origin.mti_ID} value={origin.mti_ID}>{origin.name}</option>
                                                        ))
                                                    ) : (
                                                        <option value="">No origins available</option>
                                                    )}
                                                </select>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label fw-bold">Condition</label>
                                                <select className="form-select" onChange={(e) => setFormFields({ ...formFields, mould_condition: e.target.value })}>
                                                    <option value={0}>Select Condition</option>
                                                    {getMouldConditions && getMouldConditions.length > 0 ? (
                                                        getMouldConditions.map((condition) => (
                                                            <option key={condition.mti_ID} value={condition.mti_ID}>{condition.name}</option>
                                                        ))
                                                    ) : (
                                                        <option value="">No conditions available</option>
                                                    )}
                                                </select>
                                            </div>

                                            {/* <div className="col-md-6 mb-3">
                                                <label className="form-label fw-bold">Material</label>
                                                <input type="text" className="form-control" placeholder="e.g. Steel" onChange={(e) => setFormFields({ ...formFields, mould_material: e.target.value })} />
                                            </div> */}


                                        </div>
                                    </div>
                                    {/* Form Fields */}

                                    <div className="text-end mt-4">
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => {
                                                Swal.fire({
                                                    title: 'Are you sure?',
                                                    text: "You want to save this mould?",
                                                    icon: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonColor: '#3085d6',
                                                    cancelButtonColor: '#d33',
                                                    confirmButtonText: 'Yes'
                                                }).then((result) => {
                                                    if (result.isConfirmed) {
                                                        handleUpload();
                                                    }
                                                });
                                            }}
                                        >
                                            <i className="ri-check-line me-1"></i> Save Mould
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>


                    )}
                    {isUpdating && (
                        <UpdateMouldFile onMouldFileID={onFileID} onClose={CloseModal} getMouldLibrary={getMouldLibrary} />
                    )}

                </div>

            )}

            {DownloadModalFile && (
                <div
                    className={`upload-progress-container azoomOutDown ${isMinimized ? "minimized" : ""
                        }`}
                    style={{ height: isMinimized ? "10%" : "60%" }}
                >
                    <div
                        className="upload-progress-header"
                        style={{ backgroundColor: "#545454" }}
                    >
                        <center>
                            <h5 className="text-white">Uploading Files</h5>
                        </center>
                        <div style={{ padding: 0 }}>
                            <button
                                onClick={() => setIsMinimized(!isMinimized)}
                                className="minimize-button"
                                style={{ paddingLeft: "10px" }}
                            >
                                {isMinimized ? (
                                    <button
                                        className="btn btn-outline-primary"
                                        style={{ borderRadius: "56%", marginRight: "4px" }}
                                    >
                                        <i
                                            className="ri-arrow-up-s-line"
                                            style={{ fontSize: "10px", color: "white" }}
                                        ></i>
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-outline-primary"
                                        style={{ borderRadius: "56%", marginRight: "4px" }}
                                    >
                                        <i
                                            className="ri-arrow-down-s-line"
                                            style={{ fontSize: "10px", color: "white" }}
                                        ></i>
                                    </button>
                                )}
                                <button
                                    className="btn btn-outline-primary"
                                    onClick={() => {
                                        setDownloadModalFile(false);
                                        setSelectedFiles([]);
                                        setIsMinimized(false);
                                    }}
                                    style={{ borderRadius: "56%" }}
                                >
                                    <i
                                        className="ri-close-line"
                                        style={{ fontSize: "10px", color: "white" }}
                                    ></i>
                                </button>
                            </button>
                        </div>
                    </div>
                    {!isMinimized && (
                        <div>
                            <div className="upload-progress-content">
                                {files.map((file, index) => (
                                    <div key={index} className="upload-progress-item">
                                        <span>
                                            <div style={{ width: "23px" }}>
                                                <FileIcon fileName={file.name} />
                                            </div>
                                        </span>
                                        <span className="truncate">{file.name}</span>
                                        <div
                                            style={{ width: "13%" }}
                                            className="fw-bold"
                                        >
                                            <Flat
                                                progress={file.progress}
                                                sx={{
                                                    strokeColor: `${file.progress === 100
                                                        ? "green"
                                                        : "#4281ff"
                                                        }`,
                                                    barWidth: 10,
                                                    miniCircleColor: "#095677",
                                                    miniCircleSize: 11,
                                                }}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {loadingFilesInServer && (
                                <div className="p-2 text-primary fw-bold">
                                    <p>
                                        The server is processing the files, please wait
                                        <span className="dots"></span>
                                    </p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default MyStlMouldLibrary;

